/**
 * A strongly-typed version of Object.entries to bypass TypeScript's default string widening.
 */
export const typedEntries = (obj) => {
    return Object.entries(obj);
};



//////////////////
// WEBPACK FOOTER
// ./src/utils/type-helpers.ts
// module id = 1592
// module chunks = 0